// scheduling/pages/SchedulerHome.jsx
// Landing page — redirects to the unified dashboard

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

export default function SchedulerHome() {
  const { isSuperUser, ready } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!ready) return;
    // Everyone goes to the grid (primary screen) or dashboard
    if (isSuperUser) {
      navigate('/schedule/grid', { replace: true });
    } else {
      navigate('/schedule/dashboard', { replace: true });
    }
  }, [ready, isSuperUser, navigate]);

  return (
    <div className="sched-home-loading">
      <div className="sched-home-loading-text">Loading scheduler...</div>
    </div>
  );
}
